import { useState } from "react";
import { requestHelper } from "../helpers/request-helper";
import { formatAndRaiseError } from "../helpers/general";

export function usePayGateways() {
  let [paymentGateways, setPaymentGateways] = useState<any>();
  let [loading, setLoading] = useState(false);
  let [error, setError] = useState(null);

  function retrieve() {
    setLoading(true);
    setError(null);
    return requestHelper(
      `
            query paymentTypes {
              paymentTypes {
                  payments {
                  id
                  title
                  logo
                  }
              }

          }
          `,
    )
      .then((data) => {
        setPaymentGateways({ data });
      })
      .catch(formatAndRaiseError)
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return { retrieve, paymentGateways, loading, error };
}
